var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgLoading = function SvgSvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 5.247a.75.75 0 0 1-.75-.75V.747a.75.75 0 0 1 1.5 0v3.75a.75.75 0 0 1-.75.75m0 18.75a.75.75 0 0 1-.75-.75v-3.75a.75.75 0 0 1 1.5 0v3.75a.75.75 0 0 1-.75.75M6.697 7.444a.74.74 0 0 1-.53-.22L3.515 4.572a.744.744 0 0 1 0-1.06.74.74 0 0 1 .53-.22c.2 0 .389.078.53.22l2.652 2.652a.744.744 0 0 1 0 1.06.74.74 0 0 1-.53.22m13.258 13.258a.74.74 0 0 1-.53-.22l-2.652-2.651a.74.74 0 0 1-.22-.53.749.749 0 0 1 1.28-.53l2.652 2.651c.142.141.22.33.22.53s-.078.389-.22.53a.75.75 0 0 1-.53.22M.75 12.747a.75.75 0 0 1 0-1.5H4.5a.75.75 0 0 1 0 1.5zm18.75 0a.75.75 0 0 1 0-1.5h3.75a.75.75 0 0 1 0 1.5zM4.045 20.702a.74.74 0 0 1-.53-.22.75.75 0 0 1-.22-.531c0-.201.078-.389.22-.53l2.652-2.651a.744.744 0 0 1 1.06 0c.142.142.22.33.22.531a.74.74 0 0 1-.22.53l-2.652 2.651a.74.74 0 0 1-.53.22M17.303 7.444a.74.74 0 0 1-.53-.22.74.74 0 0 1-.22-.53c0-.2.078-.389.22-.53l2.652-2.652a.744.744 0 0 1 1.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-2.652 2.652a.74.74 0 0 1-.53.22"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    calcMode: "linear",
    dur: "2s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 12 12;360 12 12"
  }))));
};
export default SvgSvgLoading;